<template>
  <div>
    <app-topsilder></app-topsilder>
  </div>
</template>

<script>
var resfulApi="https://backend.produ.com/admin/index.php/welcome/"
//var resfulApi="http://produbackend/admin/index.php/welcome/"
import Topsilder from './home/Topslider.vue'

import axios from 'axios'

export default {
  name: 'Home',
  components : {
   'app-topsilder': Topsilder
  },
  data () {
    return {
    }
  },
  created () {


  },
  methods: {
    moment: function () {
      return moment()
    }
  },
  beforeMount() {

  },
  mounted: function () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .filtro-negro a:hover{
     cursor: pointer;
  }
  a:hover{
    cursor:pointer;
  }

  @media only screen and (max-width: 650px) {

      #main-slider .carousel .slide-margin{
          margin-top: 10px !important;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue